/* ============================================================
   ALAYA JUNIOR — brand behaviour layer over Dawn's facets.js.
   Never fork Dawn's file; extend it from here.

   Mobile: close the filter drawer the moment a value is chosen so the shopper
   sees the filtered grid straight away instead of hunting for "Apply".
   ============================================================ */
(function () {
  var MOBILE = '(max-width: 749px)';

  document.addEventListener('change', function (event) {
    if (!window.matchMedia(MOBILE).matches) return;

    var input = event.target;
    if (!input || typeof input.closest !== 'function') return;
    // only filter values — not the sort <select> or the price range fields
    if (!input.matches('input[type="checkbox"], input[type="radio"]')) return;
    if (!input.closest('#FacetFiltersFormMobile')) return;

    // Dawn binds its handler to the form, so it has already run by the time this
    // bubbles up to document — closing the drawer does not cancel its fetch.
    var wrapper = document.querySelector('.mobile-facets__wrapper');
    if (!wrapper) return;
    var details = wrapper.querySelector('details.mobile-facets__disclosure');
    if (!details || !details.open) return;

    var summary = details.querySelector('summary');
    // Clicking the summary routes through Dawn's menu-drawer so the drawer runs
    // its normal slide-out animation and restores focus/scroll correctly.
    if (summary) summary.click();
  });
})();
